export default "__VITE_ASSET__DIm7dXdO__"